<div class="attachment-container" *ngIf="permissionData$| async as permissionData">
  <p class="heading-h6-medium">Attachments</p>
  <div class="center">
    <ngx-file-drop dropZoneLabel="Drag and drop files here" (onFileDrop)="dropped($event)"
      accept=".pdf, .doc, .docx, .xls, .xlsx, .tiff, .gif, .jpg, .bmp, .png, .txt, .cad, .dwg" [directory]="false"
      dropZoneClassName="file-upload-dropzone dashed"
      *ngIf="getFileUploadState(permissionData.ability.can('update',permissionData.formVendorDoc))">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <a
          (click)="getFileUploadState(permissionData.ability.can('update',permissionData.formVendorDoc)) ? openFileSelector() : null">
          <div class="upload-info-container">
            <div class="upload-info-row">
              <div class="upload-info-col icon-container icon-col-header">
                <mat-icon svgIcon="mp-cloud-update" class="upload"></mat-icon>
              </div>
              <div class="upload-info-col header">
                <p><span class="hyperlink">Choose a file</span> to upload</p>
                <p class="subheader">or drag and drop it here</p>
              </div>
            </div>
            <div class="upload-info-row">
              <div class="upload-info-col icon-container">
                <mat-icon svgIcon="mp-straighten" class="straighten"></mat-icon>
              </div>
              <div class="upload-info-col">
                <p>Max file size 50mb</p>
              </div>
            </div>
            <div class="upload-info-row">
              <div class="upload-info-col icon-container">
                <mat-icon svgIcon="mp-description" class="description"></mat-icon>
              </div>
              <div class="upload-info-col">
                <p>Refer to ServiceNow TechNet knowledge base to find the full blacklist of non-uploadable file types.</p>
              </div>
            </div>
          </div>
        </a>
      </ng-template>
    </ngx-file-drop>
    
    <!-- readonly  ngx-file-drop-->
    <div ngClass="file-upload-dropzone dashed disabled"
      *ngIf="!getFileUploadState(permissionData.ability.can('update',permissionData.formVendorDoc))">
      <a>
        <div class="upload-info-container">
          <div class="upload-info-row">
            <div class="upload-info-col icon-container icon-col-header">
              <mat-icon svgIcon="mp-cloud-update" class="upload"></mat-icon>
            </div>
            <div class="upload-info-col header">
              <p><span class="hyperlink">Choose a file</span> to upload</p>
              <p class="subheader">or drag and drop it here</p>
            </div>
          </div>
          <div class="upload-info-row">
            <div class="upload-info-col icon-container">
              <mat-icon svgIcon="mp-straighten" class="straighten"></mat-icon>
            </div>
            <div class="upload-info-col">
              <p>Max file size 50mb</p>
            </div>
          </div>
          <div class="upload-info-row">
            <div class="upload-info-col icon-container">
              <mat-icon svgIcon="mp-description" class="description"></mat-icon>
            </div>
            <div class="upload-info-col">
              <p>Refer to ServiceNow TechNet knowledge base to find the full blacklist of non-uploadable file types.</p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <!-- <div class="file-error-message" *ngIf="showErrorMessage">
      <p>{{ errorMsg }}</p>
    </div> -->
    <div class="file-upload-table-container">
      <app-add-reference-card desc="You have not uploaded any files." 
        [disabled]="isLocked" 
        *ngIf="fileUploadDS.data.length == 0 && !getFileUploadState(permissionData.ability.can('update',permissionData.formVendorDoc))"
        ngClass="app-add-reference-card">
      </app-add-reference-card>
      <app-add-reference-card desc="You have not uploaded any files." 
        tabindex="0"
        [disabled]="isLocked" 
        (keypress)="fileInput.click()"
        (click)="fileInput.click()"
        *ngIf="fileUploadDS.data.length <= 0 && getFileUploadState(permissionData.ability.can('update',permissionData.formVendorDoc))"
        ngClass="app-add-reference-card">
      </app-add-reference-card>

      <input #fileInput type="file" hidden (change)="browseFile($event)"
        accept=".pdf, .doc, .docx, .xls, .xlsx, .tiff, .gif, .jpg, .bmp, .png, .txt, .cad, .dwg" />
      <!-- <form [formGroup]="purposeForm"></form> -->
      <div class="myPurchase-table-container" *ngIf="fileUploadDS.data.length > 0">
        <table mat-table [dataSource]="fileUploadDS" class="mat-elevation-z8 file-upload-table">
          <!-- <ng-container *ngFor="let item of files; let i=index"></ng-container> -->
          <!-- Loader Column -->
          <!-- <ng-container matColumnDef="loader" class="mat-loader-container">
                    <mat-header-cell *matHeaderCellDef class="mat-loader-header">
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" class="mat-loader-cell">
                        <mat-progress-spinner [diameter]="30" [mode]="'determinate'" [value]="row.FileSize"></mat-progress-spinner>
                    </mat-cell>
                </ng-container> -->
          <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column.columnDef">
            <div class="date-uploaded" *ngIf="column.columnDef == 'DateUploaded'">
              <th mat-header-cell *matHeaderCellDef>
                {{ column.header }}
              </th>
              <td mat-cell [ngClass]="{ 'deleted-row': row.attachment.isDeleted || row.attachment.Strikethrough }"
                *matCellDef="let row">
                {{ column.cell(row) | date : "dd/MM/yyyy" }}
              </td>
            </div>
            <div class="file-name" *ngIf="column.columnDef == 'FileName'">
              <th mat-header-cell *matHeaderCellDef>
                {{ column.header }}
              </th>
              <td mat-cell [ngClass]="{ 'deleted-row': row.attachment.isDeleted || row.attachment.Strikethrough }"
                *matCellDef="let row">
                {{ column.cell(row) }}
              </td>
            </div>
            <div class="date-uploaded" *ngIf="column.columnDef == 'Action'">
              <th mat-header-cell *matHeaderCellDef class="table-cell--freeze-right">
                {{ column.header }}
              </th>
              <td mat-cell [ngClass]="{ 'deleted-row': row.attachment.isDeleted || row.attachment.Strikethrough}"
                class="table-cell--freeze-right" *matCellDef="let row; let j = index">
                <ng-container *ngIf="row.fromDatabase && !row.attachment.isDeleted && !row.attachment.Strikethrough">
                  <button mat-icon-button (click)="downloadFile(row)">
                    <mat-icon>download</mat-icon>
                  </button>
                </ng-container>
                <!-- !row.selectedPurpose || ![AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR.toString(), AttachmentTypeIdEnum.QUOTATION.toString()].includes(row.selectedPurpose) -->
                <ng-container
                  *ngIf="(!row.attachment.isDeleted && !isReadOnly && !row.attachment.Strikethrough) || 
              !(isReadOnly && !(loggedInUser.userName == CE && !(row.attachment.CreatedBy == RO || row.attachment.Created == CreatedBy) && (documentStatus.subStatus == 40  ||documentStatus.subStatus == 41))) || haveEditingRightsDuringPendingQuotation(row) || haveEditingRightsWhenTenderDC()">
                  <button mat-icon-button [hidden]="row.attachment.CreatedBy !== this.loggedInUser.userName"
                    [disabled]="row.buttonDisplay" (click)=" updateFile(null, row, j)">
                    <mat-icon>edit</mat-icon>
                  </button>

                  <button [hidden]="row.attachment.CreatedBy !== this.loggedInUser.userName" mat-icon-button
                    (click)="removeFile(j)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </ng-container>

              </td>
            </div>
            <div class="date-uploaded" *ngIf="column.columnDef == 'Purpose'">
              <th mat-header-cell *matHeaderCellDef>
                {{ column.header }}
              </th>
              <td mat-cell [ngClass]="{ 'deleted-row': row.attachment.isDeleted || row.attachment.Strikethrough}"
                *matCellDef="let row; let j = index">
                <!-- -1 because we have init a control in constructor before rendering -->
                <div class="select-container"
                  *ngIf="haveEditingRightsDuringPendingQuotation(row) || haveEditingRightsWhenTenderDC(); else defaultSelectDropdown">
                  <ng-select class="purpose-dropdown" [items]="pendingQuotationOptions" [ngModel]="row.selectedPurpose" bindLabel="value"
                    bindValue="id" (change)="updateFileDuringQuotation($event, row, j)" appearance="outline"
                    [appendTo]="'body'" [disabled]="row.attachment.isDeleted || row.attachment.Strikethrough"
                    [readonly]="row.attachment.isDeleted || row.attachment.Strikethrough">
                    <ng-template ng-option-tmp let-item="item">
                      <div [ngClass]="getOptionStyle(item)">
                        {{ item.value }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <ng-template #defaultSelectDropdown>
                  <div class="select-container">
                    <ng-select class="purpose-dropdown"
                      [disabled]="(row.attachment.CreatedBy !== this.loggedInUser.userName) || row.attachment.isDeleted || row.attachment.Strikethrough"
                      [items]="row.selectedPurposeDropdowns" [ngModel]="row.selectedPurpose" bindLabel="value"
                      bindValue="id" (change)="updateFile($event, row, j)" appearance="outline" [appendTo]="'body'"
                      [readonly]="isFileAttachmentReadonly(row) || row.attachment.isDeleted || row.attachment.Strikethrough ">
                      <ng-template ng-option-tmp let-item="item">
                        <div [ngClass]="getOptionStyle(item)">
                          {{ item.value }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </ng-template>

              </td>
            </div>
            
            <div class="other-headers" *ngIf="
              column.columnDef !== 'DateUploaded' &&
              column.columnDef !== 'Action' &&
              column.columnDef !== 'Purpose' &&
              column.columnDef !== 'FileName'
            ">
              <th mat-header-cell *matHeaderCellDef>
                {{ column.header }}
              </th>
              <td mat-cell [ngClass]="{ 'deleted-row': row.attachment.isDeleted || row.attachment.Strikethrough }"
                *matCellDef="let row">
                {{ column.cell(row) }}
              </td>
            </div>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

    </div>
    <mat-paginator *ngIf="fileUploadDS.data.length > 0" #attachmentPg [length]="fileUploadDS.data.length"
      [pageSize]="20" showFirstLastButtons [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>